import { FC, memo } from "react";
import { TWorkSession } from "../../../common/types";
import WorkSessionImageList from "./components/work-session-image-list";
import WorkSessionNotes from "./components/work-session-notes";

interface WorkSessionDetailsProps {
    workingSessionNotes?: TWorkSession['workingSessionNotes'];
    workingSessionImages?: TWorkSession['workingSessionImages'];
}

const WorkSessionDetails: FC<WorkSessionDetailsProps> = ({
    workingSessionNotes,
    workingSessionImages,
}) => {
    const hasData = workingSessionImages?.length || workingSessionNotes?.length;

    if (!hasData) {
        return null;
    }

    return (
        <>
            {workingSessionNotes?.length && (
                <WorkSessionNotes
                    data={workingSessionNotes}
                />
            )}
            {workingSessionImages?.length && (
                <WorkSessionImageList
                    data={workingSessionImages}
                />
            )}
        </>
    );
};

export default memo(WorkSessionDetails);
